/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { Dialog } from '@progress/kendo-react-dialogs'
import {
  NumericTextBox,
  Checkbox,
  TextArea,
} from '@progress/kendo-react-inputs'
import { FloatingLabel } from '@progress/kendo-react-labels'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { filterBy } from '@progress/kendo-data-query'
import { Tooltip } from '@progress/kendo-react-tooltip'

import {
  clampDurationHoursToStartDay,
  getMaxDurationHoursForStart,
  TimePickerWithEnter,
  roundDuration,
  useSyncClampedNumericTextBoxValue,
  withTooltipItemRender,
} from '@/matteroomTab/Utils'
import { getUserInfo } from '@/client'
import {
  createTimeEntry,
  mergeTimeEntries,
  searchObjects,
  formatSolrKeyword,
} from '../../../../../api/commonApi'
import { useNotification } from '@/matteroomTab/Notification/NotificationContext'
import { DescriptionEditorInline } from '@/matteroomTab/DescriptionEditorInline'
import { AsyncComboBox } from '@/matteroomTab/AsyncComboBox'
import { AsyncGroupedComboBox } from '@components/common/AsyncGroupedComboBox'
import { addDaysInUserTimeZone, getUserDayBounds } from '@utils/timeZone'
import { useConnectedAppsStore } from '@stores/useConnectedAppsStore'
import {
  getMyCaseActivityFromMetadata,
  isMyCaseBillingService,
  withMyCaseActivityMetadata,
} from '@utils/myCaseActivityMetadata'
import {
  getTimeEntryClockPickerValue,
  getTimeEntryDateKey,
  mergeTimeEntryDateAndClockTime,
  moveTimeEntryDateTimeToDate,
} from '@features/timeEntries/utils/timeEntryTime'

import EditableMyCaseActivityField from './fields/EditableMyCaseActivityField'
import EditableCodeField from './fields/EditableCodeField'
import EditableClientField from './fields/EditableClientField'
import EditableMatterField from './fields/EditableMatterField'
import TimeEntryDialogFooter from './shared/TimeEntryDialogFooter'
import TimeEntryDialogHeader from './shared/TimeEntryDialogHeader'
import CloneDurationNotice from './shared/CloneDurationNotice'
import { useCloneDailyDuration } from '../../hooks/useCloneDailyDuration'
import {
  isNarrativeOcgContextField,
  isTimeEntryDialogFormReady,
} from './shared/timeEntryDialogValidation'
import CLOSE_ICON from '@public/assets/action/close_circle.svg'
import SEARCH_ICON from '@public/assets/action/icon_zoom.svg'
import MATTER_ICON from '@public/assets/common/Icon_Matter.svg'
import CLIENT_ICON from '@public/assets/common/Icon_Client.svg'
import CHECKBOX_SELECTED from '@public/assets/button/checkbox_selected.svg'
import CHECKBOX_UNSELECTED from '@public/assets/button/checkbox_unselected.svg'

import AiTooltipWrapper from '@features/timeEntries/components/web/AiTooltipWrapper'
import DateSwitcher from '@components/common/DateSwitcher'
import {
  NarrativeOcgFieldSuggestion,
  useNarrativeOcgValidation,
} from '@features/narrativeOcg'
import {
  getNarrativeSeverity,
  hasErrors,
  hasOnlyNonBlockingFieldWarnings,
} from '@features/narrativeOcg/utils/issueDetails'
import { getOcgFieldSeverity } from '@features/narrativeOcg/utils/fieldViolations'
import { NarrativeOcgReferenceActions } from '@features/narrativeOcg/components/NarrativeOcgReferenceActions'
import { DeleteConfirmDialog } from '@components/common/dialog/DeleteConfirmDialog'
import { useBlockBillingClientIds } from '@features/grid/hooks/useBlockBillingClientIds'
import {
  BLOCK_BILLING_MERGE_DIALOG_DESCRIPTION,
  BLOCK_BILLING_MERGE_DIALOG_TITLE,
  getBlockBillingSaveMergeIds,
  getBlockBillingSaveMergeReleaseFields,
  loadBlockBillingSaveMergeEntries,
} from '@features/grid/utils/blockBillingDrop'
import { useTimeEntriesStore } from '@/stores/useTimeEntriesStore'
import { useLoadingStore } from '@/stores/useLoadingStore'

const NewTimeEntryDialog = ({
  isDelegationMode,
  selfUser,
  selectedUser,
  minMinutes,
  hasDestination,
  visible,
  codes,
  onSuccess,
  onClose,
  defaultDate,
  backgroundRefresh = false,
}) => {
  const [defaultTimeEntry] = useState(() => {
    const rawDefaultTimeEntry = localStorage.getItem('defaultNewTimeEntry')

    const defaults = rawDefaultTimeEntry
      ? {
          client_number: null,
          client_name: null,
          client_id: null,
          matter_number: null,
          matter_name: null,
          matter_id: null,
          matter_type: null,
          start: null,
          stop: null,
          duration: null,
          ...JSON.parse(rawDefaultTimeEntry), // 后面的覆盖前面的
        }
      : {
          client_number: null,
          client_name: null,
          client_id: null,
          matter_number: null,
          matter_name: null,
          matter_id: null,
          matter_type: null,
          start: null,
          stop: null,
          duration: null,
        }

    localStorage.removeItem('defaultNewTimeEntry')
    return defaults
  })
  const isCloneMode = defaultTimeEntry?.clone_mode === true

  const services = useConnectedAppsStore(state => state.services)
  const isMyCaseBilling = isMyCaseBillingService(services)
  const blockBillingClientIds = useBlockBillingClientIds()
  const existingTimeEntries =
    useTimeEntriesStore(state => state.jsonData?.datas) || []
  const now = new Date()

  const [formData, setFormData] = useState({
    date: defaultDate ?? new Date(),

    tkpr_username: isDelegationMode
      ? selectedUser?.email || ''
      : selfUser?.email ||
        getUserInfo()?.email ||
        localStorage.getItem('email') ||
        '',

    client_number: defaultTimeEntry?.client_number,
    client_name: defaultTimeEntry?.client_name,
    client_id: defaultTimeEntry?.client_id,

    matter_number: defaultTimeEntry?.matter_number,
    matter_name: defaultTimeEntry?.matter_name,
    matter_id: defaultTimeEntry?.matter_id,
    matter_type: defaultTimeEntry?.matter_type,

    start: defaultTimeEntry?.start ? new Date(defaultTimeEntry.start) : null,
    stop: defaultTimeEntry?.stop
      ? new Date(defaultTimeEntry.stop)
      : defaultDate
        ? defaultDate
        : now,
    duration: defaultTimeEntry?.duration ?? null,

    is_billable: defaultTimeEntry?.is_billable ?? true,
    description: defaultTimeEntry?.description ?? '',
    worked_on: defaultTimeEntry?.worked_on ?? '',
    task_code: defaultTimeEntry?.task_code ?? '',
    activity_code: defaultTimeEntry?.activity_code ?? '',
    metadata: defaultTimeEntry?.metadata || {},
    mycase_activity: getMyCaseActivityFromMetadata(defaultTimeEntry?.metadata),
  })

  const [matterUtbmsRequired, setMatterUtbmsRequired] = useState(false)
  // 初始化下拉数据
  const [activityOptions, setActivityOptions] = useState(
    codes?.ACTIVITYCODE?.filter(e => e.is_active) ?? []
  )
  const [taskOptions, setTaskOptions] = useState(
    codes?.TASKCODE?.filter(e => e.is_active) ?? []
  )

  const [filterActivityOptions, setFilterActivityOptions] =
    useState(activityOptions)
  const [filterTaskOptions, setFilterTaskOptions] = useState(taskOptions)

  const filterData = (options, filter) => filterBy(options, filter)

  const filterActivityChange = event => {
    setFilterActivityOptions(filterData(activityOptions, event.filter))
  }

  const filterTaskChange = event => {
    setFilterTaskOptions(filterData(taskOptions, event.filter))
  }

  const [clientVersion, setClientVersion] = useState(0)
  const [matterVersion, setMatterVersion] = useState(0)
  const [tempClients, setTempClients] = useState([])
  const [tempMatters, setTempMatters] = useState([])
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submittingAction, setSubmittingAction] = useState(null)
  const durationRef = useRef(null)
  const narrativeOutsideValidationArmedRef = useRef(false)
  const narrativeOutsideValidatingRef = useRef(false)
  const narrativeContextValidationSignatureRef = useRef(null)
  const narrativeAcceptedRef = useRef(false)
  const pendingNarrativeSubmitActionRef = useRef(null)
  const pendingBlockBillingSaveTypeRef = useRef(null)
  const pendingBlockBillingConfirmedRef = useRef(false)
  const [showBlockBillingMergeHint, setShowBlockBillingMergeHint] =
    useState(false)
  const setLoading = useLoadingStore(state => state.setLoading)
  const { showNotification } = useNotification()
  useSyncClampedNumericTextBoxValue(
    durationRef,
    formData.duration,
    minMinutes ? 1 : 2
  )

  // DateSwitcher state
  const [dateFilter, setDateFilter] = useState(3)
  const [dateStep, setDateStep] = useState(0)
  const initialSelectedDate = moment(
    getTimeEntryDateKey(formData.date) || formData.date
  )
  const [selectedWeekDay, setSelectedWeekDay] = useState({
    key: initialSelectedDate.format('ddd'),
    date: initialSelectedDate,
    mappingDate: initialSelectedDate.format('YYYY-MM-DD'),
    format: initialSelectedDate.format('YYYY/MM/DD'),
  })

  const endOfToday = new Date()
  endOfToday.setHours(23, 59, 59, 999)

  const [isFloating, setIsFloating] = useState(false)

  // 监听输入变化
  useEffect(() => {
    const inputEl = document.getElementById('new-start')
    if (!inputEl) return

    const handleInput = () => {
      const val = inputEl.value || ''
      // 判断逻辑：val 非空且不是占位符
      if (val) {
        setIsFloating(true)
      } else {
        setIsFloating(false)
      }
    }

    inputEl.addEventListener('input', handleInput)
    inputEl.addEventListener('focus', handleInput)
    inputEl.addEventListener('blur', handleInput)

    return () => {
      inputEl.removeEventListener('input', handleInput)
      inputEl.removeEventListener('focus', handleInput)
      inputEl.removeEventListener('blur', handleInput)
    }
  }, [])

  const selectedCalendarDate =
    getTimeEntryDateKey(selectedWeekDay?.mappingDate) ||
    getTimeEntryDateKey(selectedWeekDay?.date) ||
    getTimeEntryDateKey(formData.date)

  const startPickerValue = getTimeEntryClockPickerValue(formData.start)

  const cloneDailyDuration = useCloneDailyDuration({
    enabled: visible,
    dateKey: selectedCalendarDate,
    userId: (isDelegationMode ? selectedUser : selfUser)?.id,
    minMinutes,
    formData,
    setFormData,
  })

  useEffect(() => {
    if (!selectedCalendarDate) return

    const movedStart = formData.start
      ? moveTimeEntryDateTimeToDate(selectedCalendarDate, formData.start)
      : formData.start
    const dayMaximum = getMaxDurationHoursForStart(movedStart, minMinutes)
    if (formData.duration != null && formData.duration > dayMaximum) {
      cloneDailyDuration.constrainDuration(formData.duration, dayMaximum)
    }

    setFormData(prev => {
      const isValidNumber = n => typeof n === 'number' && !isNaN(n) && n >= 0
      const { end: endOfDay } = getUserDayBounds(selectedCalendarDate)

      const nextStart = prev.start
        ? moveTimeEntryDateTimeToDate(selectedCalendarDate, prev.start)
        : prev.start
      let nextStop = prev.stop
        ? moveTimeEntryDateTimeToDate(selectedCalendarDate, prev.stop)
        : prev.stop
      let nextDuration = isValidNumber(prev.duration)
        ? clampDurationHoursToStartDay(
            roundDuration(prev.duration, minMinutes),
            nextStart,
            minMinutes
          )
        : prev.duration

      if (nextStart && nextDuration != null) {
        nextStop = new Date(nextStart.getTime() + nextDuration * 3600000)
        if (endOfDay && nextStop > endOfDay) {
          nextStop = endOfDay
          nextDuration = clampDurationHoursToStartDay(
            roundDuration(
              (nextStop.getTime() - nextStart.getTime()) / 3600000,
              minMinutes
            ),
            nextStart,
            minMinutes
          )
        }
      }

      const startChanged =
        Boolean(prev.start) && nextStart?.getTime() !== prev.start.getTime()
      const stopChanged =
        Boolean(prev.stop) && nextStop?.getTime() !== prev.stop.getTime()
      const durationChanged = nextDuration !== prev.duration
      const dateChanged = prev.date !== selectedCalendarDate

      if (!dateChanged && !startChanged && !stopChanged && !durationChanged)
        return prev

      return {
        ...prev,
        date: selectedCalendarDate,
        start: nextStart,
        stop: nextStop,
        duration: nextDuration,
      }
    })
  }, [selectedCalendarDate, minMinutes])

  const handleChange = (field, value) => {
    if (field === 'duration') {
      value = cloneDailyDuration.constrainDuration(
        value,
        getMaxDurationHoursForStart(formData.start, minMinutes)
      )
    }
    const timeFields = ['start', 'stop', 'duration']
    const shouldResetNarrativeDiscard =
      field === 'description' || isNarrativeOcgContextField(field)

    if (shouldResetNarrativeDiscard) {
      pendingNarrativeSubmitActionRef.current = null
    }

    clearError(field)
    if (['duration', 'activity_code', 'task_code'].includes(field)) {
      narrativeOcg.clearFieldValidation(field)
    }
    if (field === 'description') {
      narrativeAcceptedRef.current = false
      narrativeOcg.handleNarrativeChange(value)
    }
    if (!timeFields.includes(field)) {
      if (isNarrativeOcgContextField(field)) {
        narrativeOcg.resetAcceptedSignature()
      }
      setFormData(prev => ({ ...prev, [field]: value }))
      return
    } else {
      clearError('start')
      clearError('stop')
      clearError('duration')
      clearError('duration_start')
    }

    setFormData(prev => {
      let newData = { ...prev, [field]: value }
      const { start: oldStart, stop: oldStop, duration: oldDuration } = newData
      const date = selectedCalendarDate || newData.date

      const isValidDate = d => d instanceof Date && !isNaN(d)
      const isValidNumber = n => typeof n === 'number' && !isNaN(n) && n > 0

      const { start: startOfDay, end: endOfDay } = date
        ? getUserDayBounds(date)
        : { start: null, end: null }
      const normalizeDuration = (rawDuration, durationStart) =>
        isValidNumber(rawDuration)
          ? clampDurationHoursToStartDay(
              roundDuration(rawDuration, minMinutes),
              durationStart,
              minMinutes
            )
          : null

      let start = isValidDate(oldStart) ? new Date(oldStart) : null
      let stop = isValidDate(oldStop) ? new Date(oldStop) : null
      let duration = normalizeDuration(oldDuration, start)
      if (field === 'start' && isValidDate(value))
        start = mergeTimeEntryDateAndClockTime(date, value)
      if (field === 'stop' && isValidDate(value))
        stop = mergeTimeEntryDateAndClockTime(date, value)
      if (field === 'duration') duration = normalizeDuration(value, start)
      if (start && stop && duration != null) {
        const expectedStop = new Date(start.getTime() + duration * 3600000)
        if (expectedStop > endOfDay) {
          stop = endOfDay
          duration = normalizeDuration(
            (stop.getTime() - start.getTime()) / 3600000,
            start
          )
        } else if (expectedStop.getTime() !== stop.getTime()) {
          stop = expectedStop
        }
      } else if (start && duration != null) {
        stop = new Date(start.getTime() + duration * 3600000)
        if (stop > endOfDay) {
          stop = endOfDay
          duration = normalizeDuration(
            (stop.getTime() - start.getTime()) / 3600000,
            start
          )
        }
      } else if (stop && duration != null && field !== 'start') {
        start = new Date(stop.getTime() - duration * 3600000)
        if (start < startOfDay) {
          start = startOfDay
          duration = normalizeDuration(
            (stop.getTime() - start.getTime()) / 3600000,
            start
          )
        }
      } else if (start && stop) {
        duration = normalizeDuration(
          (stop.getTime() - start.getTime()) / 3600000,
          start
        )
        if (duration <= 0) {
          stop = new Date(start.getTime())
          duration = null
        }
        if (stop > endOfDay) {
          stop = endOfDay
          duration = normalizeDuration(
            (stop.getTime() - start.getTime()) / 3600000,
            start
          )
        }
      }

      if (start && startOfDay && start < startOfDay) start = startOfDay
      if (stop && endOfDay && stop > endOfDay) stop = endOfDay

      return { ...newData, date, start, stop, duration }
    })
  }

  useEffect(() => {
    if (!formData?.matter_id) {
      setMatterUtbmsRequired(false)
      return
    }

    const fetchMatter = async () => {
      try {
        const res = await searchObjects(
          'matter',
          formData.matter_id,
          0,
          1,
          'obj_id,number,utbms_required',
          `obj_id:(${formData.matter_id})`,
          hasDestination
        )

        const matter = res?.[0]

        setMatterUtbmsRequired(!!matter?.utbms_required)
      } catch (e) {
        console.error('Failed to fetch matter utbms_required', e)
      }
    }

    fetchMatter()
  }, [formData?.matter_id])

  useEffect(() => {
    if (!matterUtbmsRequired) {
      setErrors(prev => ({
        ...prev,
        activity_code: '',
        task_code: '',
      }))
    }
  }, [matterUtbmsRequired])

  const validate = () => {
    const newErrors = {}
    if (!formData.client_number) newErrors.client_number = 'Client is required'
    if (!formData.matter_number) newErrors.matter_number = 'Matter is required'
    if (!formData.start && !formData.duration)
      newErrors.duration_start = 'Both Duration and Start are required'
    if (!formData.start) newErrors.start = 'Start is required'
    if (!formData.stop) newErrors.stop = 'Stop is required'
    if (!formData.duration || formData.duration <= 0)
      newErrors.duration = 'Duration must be > 0'
    if (!formData.description) newErrors.description = 'Narrative is required'
    if (isMyCaseBilling && !String(formData.mycase_activity || '').trim()) {
      newErrors.mycase_activity = 'Activity is required'
    }
    // ✅ 新增：UTBMS 必填逻辑
    if (matterUtbmsRequired) {
      if (!formData.activity_code) {
        newErrors.activity_code = 'Activity Code is required'
      }
      if (!formData.task_code) {
        newErrors.task_code = 'Task Code is required'
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const buildNarrativeValidationItem = start => ({
    ...formData,
    id: undefined,
    date: selectedCalendarDate,
    recorded_at: start || new Date(),
    start,
    hours: String(formData.duration ?? 0),
    rate: (isDelegationMode ? selectedUser : selfUser)?.default_rate ?? null,
    timekeeper_id: formData.tkpr_username,
  })

  const narrativeOcg = useNarrativeOcgValidation({
    description: formData.description,
    clientId: formData.client_id,
    timekeeperId: (isDelegationMode ? selectedUser : selfUser)?.id,
    isBillable: formData.is_billable,
    getValidationNarrative: (_start, description) =>
      description ?? formData.description,
    getSignaturePayload: (description = formData.description) => ({
      description: description || '',
      client_id: formData.client_id || null,
      client_number: formData.client_number || null,
      matter_id: formData.matter_id || null,
      matter_number: formData.matter_number || null,
    }),
    buildValidationItem: buildNarrativeValidationItem,
    onApplyNarrative: narrative => handleChange('description', narrative),
    resetDeps: [formData.client_id, formData.client_number, formData.is_billable],
  })

  const durationOcgSeverity = getOcgFieldSeverity(
    narrativeOcg.validationHint,
    'duration'
  )
  const activityOcgSeverity = getOcgFieldSeverity(
    narrativeOcg.validationHint,
    'activity_code'
  )
  const taskOcgSeverity = getOcgFieldSeverity(
    narrativeOcg.validationHint,
    'task_code'
  )

  const handleAcceptValidation = suggestedNarrative => {
    // MIRA-4223: accepting narrative changes must preserve entered time. Duration
    // suggestions are applied only through the duration field's own action.
    narrativeOcg.handleAccept(suggestedNarrative || formData.description || '')
    narrativeAcceptedRef.current = true
    narrativeOutsideValidationArmedRef.current = false
  }

  useEffect(() => {
    narrativeOutsideValidationArmedRef.current = false
    narrativeAcceptedRef.current = false
    if (!formData.client_number) {
      narrativeOcg.clearValidationHint()
    }
  }, [formData.client_number])

  useEffect(() => {
    const contextSignature = JSON.stringify({
      client_id: formData.client_id || null,
      client_number: formData.client_number || null,
      matter_id: formData.matter_id || null,
      matter_number: formData.matter_number || null,
    })

    if (!formData.client_number || !String(formData.description || '').trim()) {
      narrativeContextValidationSignatureRef.current = contextSignature
      return
    }

    if (narrativeContextValidationSignatureRef.current === null) {
      narrativeContextValidationSignatureRef.current = contextSignature
      return
    }

    if (narrativeContextValidationSignatureRef.current === contextSignature)
      return

    narrativeContextValidationSignatureRef.current = contextSignature
    if (narrativeAcceptedRef.current) return

    const start = moveTimeEntryDateTimeToDate(
      selectedCalendarDate,
      formData.start
    )
    void narrativeOcg.validateBeforeSubmit(start)
  }, [
    formData.client_id,
    formData.client_number,
    formData.matter_id,
    formData.matter_number,
  ])

  const isNarrativeOcgBlocking =
    Boolean(narrativeOcg.validationHint?.isLoading) ||
    hasErrors(narrativeOcg.validationHint) ||
    getNarrativeSeverity(narrativeOcg.validationHint) === 'warning'
  const isFormReady = isTimeEntryDialogFormReady(formData, {
    matterUtbmsRequired,
    isMyCaseBilling,
  })

  const handleNarrativeInteraction = () => {
    if (formData.client_number) {
      narrativeOutsideValidationArmedRef.current = true
    }
  }

  const handleNarrativeOutsideClick = async (event, latestNarrative) => {
    const target = event?.target instanceof Element ? event.target : null
    if (target?.closest('button')) return
    if (narrativeAcceptedRef.current) return
    if (!narrativeOutsideValidationArmedRef.current) return
    const narrative = latestNarrative ?? formData.description
    if (!formData.client_number || !String(narrative || '').trim()) return
    if (
      narrativeOcg.validationHint?.visible ||
      narrativeOcg.validationHint?.isLoading
    )
      return
    if (narrativeOutsideValidatingRef.current) return

    narrativeOutsideValidatingRef.current = true
    try {
      const start = moveTimeEntryDateTimeToDate(
        selectedCalendarDate,
        formData.start
      )
      await narrativeOcg.validateBeforeSubmit(start, narrative)
    } finally {
      narrativeOutsideValidatingRef.current = false
    }
  }

  const clearError = field => {
    setErrors(prev => ({
      ...prev,
      [field]: '',
    }))
  }

  const handleSubmit = async type => {
    if (cloneDailyDuration.blocked) return
    const skipFieldValidation = hasOnlyNonBlockingFieldWarnings(
      narrativeOcg.validationHint
    ) && !narrativeOcg.isFieldValidationDirty
    if (!skipFieldValidation && isNarrativeOcgBlocking) return
    if (!validate()) return
    setIsSubmitting(true)
    setSubmittingAction(type)
    const start = moveTimeEntryDateTimeToDate(
      selectedCalendarDate,
      formData.start
    )
    let stop = moveTimeEntryDateTimeToDate(selectedCalendarDate, formData.stop)

    if (start && stop && stop < start) {
      stop = addDaysInUserTimeZone(stop, 1) || stop
    }

    const dt = start
    const narrativeIsValid = await narrativeOcg.validateBeforeSubmit(start)
    if (!narrativeIsValid) {
      pendingNarrativeSubmitActionRef.current = type
      setIsSubmitting(false)
      setSubmittingAction(null)
      return
    }

    const fieldsAreValid =
      skipFieldValidation || (await narrativeOcg.validateBeforeSave(start))
    if (!fieldsAreValid) {
      pendingNarrativeSubmitActionRef.current = type
      setIsSubmitting(false)
      setSubmittingAction(null)
      return
    }

    pendingNarrativeSubmitActionRef.current = null

    const liveEntries = await loadBlockBillingSaveMergeEntries({
      dateKey: selectedCalendarDate,
      userId: selectedUser?.id,
      fallbackEntries: existingTimeEntries,
      clientId: formData.client_id,
      blockBillingClientIds,
    })
    const mergeExistingIds =
      getBlockBillingSaveMergeIds({
        clientId: formData.client_id,
        matterNumber: formData.matter_number,
        date: selectedCalendarDate,
        existingEntries: liveEntries,
        blockBillingClientIds,
      }) ?? []
    if (mergeExistingIds.length && !pendingBlockBillingConfirmedRef.current) {
      pendingBlockBillingSaveTypeRef.current = type
      setShowBlockBillingMergeHint(true)
      setIsSubmitting(false)
      setSubmittingAction(null)
      return
    }

    const willMerge = Boolean(mergeExistingIds.length)
    const mergeReleaseFields = getBlockBillingSaveMergeReleaseFields(type)

    try {
      const commonPayload = {
        tkpr_username: formData.tkpr_username,
        client_number: formData.client_number || null,
        client_name: formData.client_name || null,
        client_id: formData.client_id || null, // ✅ 新增
        matter_number: formData.matter_number || null,
        matter_name: formData.matter_name || null,
        matter_id: formData.matter_id || null, // ✅ 新增
        matter_type: formData.matter_type || null,
        start: start || null,
        stop: stop || null,
        is_billable: formData.is_billable,
        description: formData.description || null,
        worked_on: formData.worked_on,
        task_code: formData.task_code ? formData.task_code.code : null,
        activity_code: formData.activity_code
          ? formData.activity_code.code
          : null,
        non_svc_source: 'Mira App',
        source_obj_id: `mira_app_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
        duration: null,
      }
      const payload = {
        ...commonPayload,
        dt,
        // 'created' + approved_by is Ready to Release; 'ready2release' is
        // Releasing. Clones follow the normal Save flow.
        status: type === 'save' || willMerge ? 'created' : 'ready2release',
        destination_status: type === 'save' || willMerge ? null : 'Pending',
        metadata: withMyCaseActivityMetadata(
          formData.metadata,
          formData.mycase_activity,
          isMyCaseBilling
        ),
        approved_by: selfUser.id,
        approved_on: new Date().toISOString(),
        time_slots: [{ ...commonPayload }],
      }

      const response = await createTimeEntry(payload) // ⏱️ 调用接口
      const createdId = response?.data?.id ?? response?.id
      let finalEntryId = createdId
      try {
        if (createdId != null && willMerge) {
          const merged = await mergeTimeEntries({
            ids: [createdId, ...mergeExistingIds],
            approved_by: selfUser.id,
            approved_on: new Date().toISOString(),
            ...mergeReleaseFields,
          })
          finalEntryId = merged?.data?.id ?? merged?.id ?? createdId
        }
      } catch (mergeError) {
        showNotification({
          type: 'error',
          message:
            mergeError?.message ||
            'Failed to merge time entries. Please try again.',
        })
      }

      pendingBlockBillingConfirmedRef.current = false
      pendingBlockBillingSaveTypeRef.current = null
      const refreshAfterCreate = async () => {
        try {
          if (willMerge || backgroundRefresh) {
            await onSuccess?.({
              updatedEntryIds: [createdId, finalEntryId, ...mergeExistingIds].filter(
                id => id != null
              ),
              createdEntryId: finalEntryId,
            })
          } else {
            await onSuccess?.()
          }
        } catch (refreshError) {
          // Creation already succeeded; a refresh failure must not invite a retry.
          console.error('Time entry saved, but failed to refresh data:', refreshError)
        }
      }

      if (willMerge) {
        onClose()
        await new Promise(resolve => requestAnimationFrame(resolve))
        if (!backgroundRefresh) setLoading(true)
        try {
          await refreshAfterCreate()
        } finally {
          if (!backgroundRefresh) setLoading(false)
        }
      } else {
        if (backgroundRefresh) {
          await refreshAfterCreate()
        } else void refreshAfterCreate()
        onClose()
      }
    } catch (error) {
      showNotification({
        type: 'error',
        message:
          error?.message || 'Failed to create time entry. Please try again.',
      })
      setIsSubmitting(false)
      setSubmittingAction(null)
    }
  }

  const handleDiscardValidation = () => {
    const start = moveTimeEntryDateTimeToDate(
      selectedCalendarDate,
      formData.start
    )
    narrativeOcg.handleDiscard(formData.description, start)

    const pendingAction = pendingNarrativeSubmitActionRef.current
    if (!pendingAction) return

    pendingNarrativeSubmitActionRef.current = null
    handleSubmit(pendingAction)
  }

  return visible ? (
    <>
    <Dialog
      className="[&_.k-dialog]:!max-h-[90vh] [&_.k-dialog]:!overflow-hidden [&_.k-window-content]:!min-h-0 [&_.k-window-content]:!overflow-hidden [&_.k-window]:overflow-hidden [&_.k-window]:rounded-xl [&_.k-window]:border-0"
      width={800}
    >
      <div className="flex max-h-[90vh] flex-col overflow-hidden rounded-xl bg-white">
        <TimeEntryDialogHeader
          title={isCloneMode ? 'Clone Time Entry' : undefined}
          onClose={onClose}
          disabled={isSubmitting}
        />

        {/* 表单 */}
        <div
          aria-disabled={isSubmitting}
          className={`flex min-h-0 w-[800px] flex-col gap-5 overflow-y-auto p-5 transition-opacity ${isSubmitting ? 'pointer-events-none cursor-not-allowed opacity-60' : ''}`}
        >
          {/* 第一行：Date + Billable */}
          <div className="flex items-center justify-between gap-5">
            <div>
              <DateSwitcher
                filter={dateFilter}
                setFilter={setDateFilter}
                step={dateStep}
                setStep={setDateStep}
                selectedWeekDay={selectedWeekDay}
                setSelectedWeekDay={setSelectedWeekDay}
                position="left"
                showOption={false}
              />
            </div>

            {/* Client */}
            <EditableClientField
              value={formData.client_number}
              displayValue={`${formData.client_number || ''} ${formData.client_name || ''}`.trim()}
              tooltipValue={`${formData.client_number || ''} ${formData.client_name || ''}`}
              tempClients={tempClients}
              clientVersion={clientVersion}
              setClientVersion={setClientVersion}
              setMatterVersion={setMatterVersion}
              setTempClients={setTempClients}
              setFormData={setFormData}
              hasDestination={hasDestination}
              fetchOptions={async q => {
                const _q = formatSolrKeyword(q)
                const filter = `(((number:*${_q}*) OR (name:*${_q}*)) AND is_active:true)`
                return searchObjects(
                  'client',
                  q,
                  0,
                  40,
                  'obj_id,name,number',
                  filter,
                  hasDestination
                )
              }}
              onChange={(val, raw) => {
                if (!val) {
                  setFormData(prev => ({
                    ...prev,
                    client_number: '',
                    client_name: '',
                    client_id: null,
                    matter_number: '',
                    matter_name: '',
                    matter_id: null,
                    matter_type: null,
                  }))
                } else {
                  setFormData(prev => ({
                    ...prev,
                    client_number: val,
                    client_name: raw?.name || '',
                    client_id: raw?.obj_id || null,
                  }))
                }
                setClientVersion(v => v + 1)
                setMatterVersion(v => v + 1)
              }}
              error={errors.client_number}
              clearError={filed => clearError(filed)}
            />
          </div>

          {/* 第二行：Duration + Start + Stop + Now */}
          <div className="flex items-center justify-between gap-5">
            <div>
              <div className="flex items-center">
                <div className="relative mr-1.5 w-[100px]">
                  <FloatingLabel
                    label="* Duration"
                    editorId="new-duration"
                    editorValue={formData.duration} // ✅ 注意这里只判断有值，不受 focus 控制
                    editorValid={
                      !errors.duration && durationOcgSeverity !== 'error'
                    }
                    className="custom-floating-label"
                  >
                    <NumericTextBox
                      id="new-duration"
                      ref={durationRef}
                      className={`h-10 w-[100px] ${errors.duration || durationOcgSeverity === 'error' ? 'form-error-border' : ''} ${durationOcgSeverity === 'warning' ? 'ocg-field-warning' : ''}`}
                      value={formData.duration ?? null}
                      min={0}
                      // MIRA-4223: clamp in handleChange so the attempted value
                      // remains available for the adjustment notice.
                      step={0.1}
                      onChange={e => {
                        let val = e.value
                        if (val != null) {
                          val = minMinutes
                            ? Math.round(val * 10) / 10
                            : Math.round(val * 100) / 100
                        }
                        handleChange('duration', val)
                      }}
                    />
                  </FloatingLabel>
                  <NarrativeOcgFieldSuggestion
                    field="duration"
                    validationHint={narrativeOcg.validationHint}
                    currentValue={formData.duration}
                    onAccept={value => handleChange('duration', Number(value))}
                  />
                  {!errors.duration_start && errors.duration && (
                    <div className="error-text">{errors.duration}</div>
                  )}
                </div>

                <span className="mr-3 text-base text-[#333]">hrs</span>

                <div className="w-[150px]">
                  <FloatingLabel
                    label={isFloating ? '' : '* Start'}
                    editorId="new-start"
                    editorValue={formData.start ? 'filled' : ''}
                    editorValid={!errors.start}
                    className="custom-floating-label"
                  >
                    <TimePickerWithEnter
                      id="new-start"
                      className="custom-time-picker"
                      value={startPickerValue}
                      onChange={e => handleChange('start', e.value)}
                      error={errors.start}
                    />
                  </FloatingLabel>
                  {!errors.duration_start && errors.start && (
                    <div className="error-text">{errors.start}</div>
                  )}
                </div>

                <div className="ml-3 flex items-center gap-2">
                  <div
                    className="h-5 w-5"
                    onClick={() =>
                      handleChange('is_billable', !formData.is_billable)
                    }
                  >
                    <img
                      src={
                        formData.is_billable
                          ? CHECKBOX_SELECTED
                          : CHECKBOX_UNSELECTED
                      }
                      alt={formData.is_billable ? 'selected' : 'unselected'}
                      className="h-5 w-5"
                    />
                  </div>
                  <span className="text-sm font-normal text-[#333]">
                    Billable
                  </span>
                </div>
              </div>
              <CloneDurationNotice {...cloneDailyDuration} />
              {errors.duration_start && (
                <div className="error-text">{errors.duration_start}</div>
              )}
            </div>

            {/* Matter */}
            <EditableMatterField
              value={formData.matter_number}
              displayValue={`${formData.matter_number || ''} ${formData.matter_name || ''}`.trim()}
              tooltipValue={`${formData.client_number || ''} ${formData.client_name || ''} | ${formData.matter_number || ''} ${formData.matter_name || ''}`}
              tempMatters={tempMatters}
              setTempMatters={setTempMatters}
              setClientVersion={setClientVersion}
              matterVersion={matterVersion}
              setMatterVersion={setMatterVersion}
              hasDestination={hasDestination}
              formData={formData}
              setFormData={setFormData}
              fetchOptions={async q => {
                const filter = formData.client_number
                  ? `client_number:(${formData.client_number})`
                  : ''
                return searchObjects(
                  'matter',
                  q,
                  0,
                  40,
                  'obj_id,name,number,client_id,client_number,client_name,is_billable,type,utbms_required',
                  filter,
                  hasDestination
                )
              }}
              onChange={(val, raw) => {
                const normalize = v => (Array.isArray(v) ? v[0] : v)
                const client_number = normalize(raw?.client_number)
                const client_name = normalize(raw?.client_name)
                setFormData(prev => ({
                  ...prev,
                  matter_number: val,
                  matter_name: normalize(raw?.name),
                  matter_id: normalize(raw?.obj_id),
                  matter_type: normalize(raw?.type),
                  client_number,
                  client_name,
                  client_id: normalize(raw?.client_id),
                  is_billable: raw?.is_billable ?? prev.is_billable,
                }))
                setClientVersion(v => v + 1)
                setMatterVersion(v => v + 1)
              }}
              error={errors.matter_number}
              clearError={filed => clearError(filed)}
            />
          </div>

          {/* 第三行：Narrative */}
          <div className={errors.description ? 'form-error' : ''}>
            <FloatingLabel
              label="* Narrative"
              editorId="new-description"
              editorValue={formData.description}
              editorValid={errors.description ? false : true}
              className="custom-floating-label"
            >
              <DescriptionEditorInline
                id="new-description"
                value={formData.description}
                item={formData}
                onChange={val => handleChange('description', val)}
                defaultIsEditing={true}
                showTemplateShortcutHint={true}
                validationHint={narrativeOcg.validationHint}
                onAcceptValidation={handleAcceptValidation}
                onDiscardValidation={handleDiscardValidation}
                onRevertValidation={narrativeOcg.handleRevert}
                validationActionLoading={narrativeOcg.actionLoading}
                onNarrativeInteraction={handleNarrativeInteraction}
                onNarrativeOutsideClick={handleNarrativeOutsideClick}
                dialogActions
                disabled={isSubmitting}
              />
            </FloatingLabel>

            {errors.description && (
              <div className="error-text">{errors.description}</div>
            )}
          </div>

          {/* 第四行：Activity + Task */}
          <div className="flex items-start gap-3">
            {isMyCaseBilling && (
              <EditableMyCaseActivityField
                value={formData.mycase_activity}
                onChange={val => handleChange('mycase_activity', val)}
                error={errors.mycase_activity}
              />
            )}

            <EditableCodeField
              label="Activity Code"
              required={matterUtbmsRequired}
              value={formData.activity_code}
              options={activityOptions}
              filterOptions={filterActivityOptions}
              setFilterOptions={setFilterActivityOptions}
              onFilterChange={filterActivityChange}
              onChange={val => handleChange('activity_code', val)}
              error={errors.activity_code}
              ocgSeverity={activityOcgSeverity}
            />

            <EditableCodeField
              label="Task Code"
              required={matterUtbmsRequired}
              value={formData.task_code}
              options={taskOptions}
              filterOptions={filterTaskOptions}
              setFilterOptions={setFilterTaskOptions}
              onFilterChange={filterTaskChange}
              onChange={val => handleChange('task_code', val)}
              error={errors.task_code}
              ocgSeverity={taskOcgSeverity}
            />
          </div>
        </div>
        <div className="w-[800px] shrink-0">
          <AiTooltipWrapper />
        </div>
        <TimeEntryDialogFooter
          disabled={isSubmitting || !isFormReady || isNarrativeOcgBlocking || cloneDailyDuration.blocked}
          interactionLocked={isSubmitting}
          saveAndReleaseLoading={submittingAction === 'submit'}
          saveLoading={submittingAction === 'save'}
          onCancel={onClose}
          onSaveAndRelease={() => handleSubmit('submit')}
          onSave={() => handleSubmit('save')}
          referenceActions={
            narrativeOcg.validationHint?.visible && !isSubmitting ? (
              <NarrativeOcgReferenceActions
                validationHint={narrativeOcg.validationHint}
              />
            ) : null
          }
        />
      </div>
    </Dialog>
    {showBlockBillingMergeHint && (
      <DeleteConfirmDialog
        title={BLOCK_BILLING_MERGE_DIALOG_TITLE}
        description={BLOCK_BILLING_MERGE_DIALOG_DESCRIPTION}
        confirmText="Ok"
        onClose={() => {
          pendingBlockBillingConfirmedRef.current = false
          pendingBlockBillingSaveTypeRef.current = null
          setShowBlockBillingMergeHint(false)
        }}
        onConfirm={() => {
          const pendingType = pendingBlockBillingSaveTypeRef.current
          pendingBlockBillingConfirmedRef.current = true
          setShowBlockBillingMergeHint(false)
          if (pendingType) handleSubmit(pendingType)
        }}
      />
    )}
    </>
  ) : null
}

export default NewTimeEntryDialog
